import React from "react"
import Bowser from "bowser"

import { ImgFluid, Img400pxMaxFluid } from "../"
// import BubbleBottleVideoHQ from "../../assets/video/bottle_bubble_3_hq_large_2.mp4"
import BubbleBottleVideo from "../../assets/video/bottle_bubble_6.mp4"
// import BubbleBottleVideo from "../../assets/video/bottle_bubble_3_hq_small.mp4"
import s from "./BottleWithDroplets.module.scss"
import { checkClipPathSupport } from "../../helper"

// static and depends on svg in clipPath
const svgDefaultWidth = 1001,
  svgDefaultHeight = 2112
// const svgDefaultWidth = 233,
//   svgDefaultHeight = 819

class BottleWithDroplets extends React.PureComponent {
  constructor(props) {
    super(props)
    this.video = React.createRef()
    this.video_hq = React.createRef()
    this.wrapper = props.WrapperRef || React.createRef()
    const uniqueId = "_" + (Math.random() * 10000000).toFixed(0)
    this.state = {
      svgScale: {
        x: 0,
        y: 0,
      },
      browserDoesntSupport: false,
      firstVideoLoaded: false,
      secondVideoLoaded: false,
      isMobile: false,
      uniqueId,
      deferHasCompleted: false,
      imageCompletedLoad: false,
    }
    this.intervalCount = 0
  }

  componentDidUpdate(prevProps) {
    if (this.props.recalcMaskSignal !== prevProps.recalcMaskSignal) {
      setTimeout(() => {
        this.calcSvgScale()
      }, 50)
    }
  }

  onFirstLoad = () => {
    const { innerWidth } = window

    // is not tablet or mobile
    if (innerWidth > 900) {
      this.setState(
        {
          firstVideoLoaded: true,
        },
        () => {
          this.secondVideoCheckInterval = setInterval(() => {
            this.checkSecondVideoLoad()
          }, 100)
        }
      )
    }
  }

  checkSecondVideoLoad = () => {
    const video = this.video_hq.current
    if (video && video.readyState === 4) {
      this.setState({
        secondVideoLoaded: true,
      })
      clearInterval(this.secondVideoCheckInterval)
    }
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      const supports = checkClipPathSupport(window, Bowser)
      if (!supports) {
        return this.setState({
          browserDoesntSupport: true,
        })
      }
    }
    const { deferVideoLoad } = this.props
    this.calcSvgScale()
    if (deferVideoLoad) {
      this.deferTimeout = setTimeout(() => {
        this.setState(
          {
            deferHasCompleted: true,
          },
          () => {
            setTimeout(() => {
              this.init()
            }, 50)
          }
        )
      }, 2500)
    } else {
      this.init()
    }
  }

  init = () => {
    const video = this.video.current
    if (!video) return
    // video.addEventListener("play", this.onFirstLoad)
    video.playbackRate = 0.8
    if (window.matchMedia("(prefers-reduced-motion)").matches) {
      video.removeAttribute("autoplay")
      video.pause()
    }
    this.calcSvgScale()
    this.updateInterval = setInterval(() => {
      this.calcSvgScale()
      if (++this.intervalCount > 10) clearInterval(this.updateInterval)
    }, 300)
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.calcSvgScale)
    }
  }
  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.calcSvgScale)
    }
    clearInterval(this.updateInterval)
    clearTimeout(this.deferTimeout)
  }
  calcSvgScale = () => {
    const wrapper = this.wrapper.current
    // const { x, y } = this.svgScale
    const { x, y } = this.state.svgScale
    if (wrapper) {
      const nextX = wrapper.clientWidth / svgDefaultWidth
      const nextY = wrapper.clientHeight / svgDefaultHeight
      if (x !== nextX || y !== nextY || this.props.recalcMaskSignal) {
        this.setState({
          svgScale: {
            x: wrapper.clientWidth / svgDefaultWidth,
            y: wrapper.clientHeight / svgDefaultHeight,
          },
        })
      }
    }
  }

  setVideoSpeedTo = (video, speed, opacity, isEnter) => {
    if (isEnter && this.props.onEnter) {
      this.props.onEnter()
    } else if (!isEnter && this.props.onLeave) {
      this.props.onLeave()
    }
    if (video) {
      video.playbackRate = speed
      // video.style.opacity = opacity
    }
  }

  onImageLoad = () => {
    if (typeof this.props.onImageLoad === "function") this.props.onImageLoad()
    this.setState({
      imageCompletedLoad: true,
    })
  }

  render() {
    const { x, y } = this.state.svgScale
    const imageName = this.props.imageName || "rivella_bottle_red.png"
    const ImageComponent = this.props.isSmallBottle
      ? Img400pxMaxFluid
      : ImgFluid
    const { style = {} } = this.props
    let wrapperStyles = [s.BottleWithDropletsWrapper]
    if (this.props.fadeInVideo) wrapperStyles.push(s.FadeInVideoWrapper)
    return (
      <div
        className={wrapperStyles.join(" ")}
        ref={this.wrapper}
        onMouseEnter={() =>
          this.setVideoSpeedTo(this.video.current, 1.2, 1, true)
        }
        onMouseLeave={() =>
          this.setVideoSpeedTo(this.video.current, 0.8, 1, false)
        }
        style={{
          ...style,
          WebkitClipPath: !this.state.browserDoesntSupport
            ? `url(#${this.state.uniqueId})`
            : null,
          clipPath: !this.state.browserDoesntSupport
            ? `url(#${this.state.uniqueId})`
            : null,
        }}
      >
        {(!this.props.deferVideoLoad || this.state.deferHasCompleted) &&
        !this.state.browserDoesntSupport ? (
          <video
            width={"100%"}
            ref={this.video}
            src={BubbleBottleVideo}
            loop
            autoPlay
            muted
            playsInline
            style={{
              visibility: this.props.hideVideo ? "hidden" : null,
              opacity:
                this.state.imageCompletedLoad && !this.props.hideVideo ? 1 : 0,
            }}
          />
        ) : // <>
        //   {this.state.firstVideoLoaded ? (
        //     <video
        //       width={"100%"}
        //       ref={this.video_hq}
        //       src={BubbleBottleVideoHQ}
        //       loop
        //       autoPlay
        //       muted
        //       playsInline
        // style={{
        //   visibility: this.props.hideVideo ? "hidden" : null,
        //   opacity: this.state.imageCompletedLoad ? 1 : 0,
        // }}
        //     />
        //   ) : null}
        //   {!this.state.secondVideoLoaded ? (
        //     <video
        //       width={"100%"}
        //       ref={this.video}
        //       src={BubbleBottleVideo}
        //       loop
        //       autoPlay
        //       muted
        //       playsInline
        // style={{
        //   visibility: this.props.hideVideo ? "hidden" : null,
        //   opacity: this.state.imageCompletedLoad ? 1 : 0,
        // }}        //     />
        //   ) : null}
        // </>
        null}
        <div className={s.BottleWrapper}>
          <ImageComponent
            fileName={imageName}
            alt={this.props.alt}
            itemProp={this.props.itemProp}
            fadeIn={this.props.dontFadeInImage === true ? false : null}
            onLoad={this.onImageLoad}
          />
        </div>
        {/* used by other components to give overlay over with global classname */}
        <div className="custom_overlay"></div>
        <svg width="0" height="0">
          <defs>
            <clipPath id={this.state.uniqueId}>
              <path
                style={{ transform: `scale(${x}, ${y})` }}
                d="M 286.609375 20.605469 C 308 0 414.945312 0 498.359375 0 C 718.667969 0 714.390625 14.164062 720.804688 39.921875 C 725.9375 60.527344 727.222656 109.464844 727.222656 131.355469 L 720.804688 131.355469 L 720.804688 184.15625 C 720.804688 185.445312 718.667969 188.019531 714.390625 188.019531 C 710.964844 188.019531 701.554688 189.738281 697.277344 190.59375 C 714.390625 198.320312 750.75 203.730469 750.75 209.914062 C 750.75 216.09375 714.390625 215.0625 697.277344 216.351562 C 697.277344 244.683594 701.984375 295.164062 703.695312 301.347656 C 705.832031 309.074219 780.695312 350.28125 804.222656 374.75 C 881.222656 446.867188 909.027344 477.777344 938.972656 531.863281 C 968.917969 585.953125 988.167969 658.066406 988.167969 667.082031 C 988.167969 676.097656 979.609375 681.25 979.609375 692.839844 C 979.609375 704.429688 992.445312 712.15625 992.445312 718.59375 C 992.445312 725.035156 983.890625 731.472656 983.890625 739.199219 C 983.890625 746.925781 996.722656 755.941406 996.722656 762.378906 C 996.722656 768.820312 986.027344 772.683594 986.027344 782.984375 C 986.027344 793.289062 994.582031 797.152344 994.582031 810.027344 C 994.582031 822.90625 981.75 825.484375 981.75 835.785156 C 981.75 846.085938 988.167969 846.085938 988.167969 858.964844 C 988.167969 871.84375 968.917969 887.296875 968.917969 892.449219 C 968.917969 897.601562 977.472656 909.191406 977.472656 916.917969 C 977.472656 924.644531 958.222656 946.535156 958.222656 952.976562 C 958.222656 959.414062 966.777344 976.15625 964.640625 982.59375 C 962.5 989.035156 947.527344 1010.925781 947.527344 1017.367188 C 947.527344 1023.804688 958.222656 1043.121094 958.222656 1049.5625 C 958.222656 1056 941.109375 1070.164062 941.109375 1086.90625 C 941.109375 1103.648438 951.804688 1108.800781 951.804688 1116.527344 L 951.804688 1705.054688 C 977.472656 1766.867188 983.890625 1809.367188 988.167969 1838.984375 C 992.445312 1868.605469 998.859375 1943.296875 998.859375 1976.78125 C 998.859375 2010.261719 962.5 2055.335938 941.109375 2074.652344 C 919.722656 2093.972656 864.109375 2105.5625 832.027344 2105.5625 C 806.359375 2105.5625 761.445312 2096.976562 742.195312 2092.683594 C 714.816406 2094.742188 648.082031 2090.964844 618.140625 2088.820312 C 592.472656 2102.984375 553.972656 2110.710938 545.417969 2110.710938 L 474.832031 2110.710938 C 433.765625 2110.710938 397.832031 2097.835938 385 2091.394531 C 374.304688 2095.257812 297.304688 2092.683594 273.777344 2092.683594 C 250.25 2092.683594 220.304688 2100.410156 203.195312 2102.984375 C 186.082031 2105.5625 124.054688 2106.847656 94.109375 2093.972656 C -23.527344 2046.320312 2.136719 1921.40625 6.414062 1876.332031 C 9.839844 1840.273438 34.933594 1739.394531 47.054688 1693.464844 L 47.054688 1115.238281 C 51.332031 1108.800781 59.886719 1090.769531 59.886719 1079.179688 C 59.886719 1067.589844 42.777344 1061.152344 42.777344 1046.984375 C 42.777344 1032.820312 53.472656 1027.667969 53.472656 1016.078125 C 53.472656 1004.488281 29.945312 983.882812 34.222656 976.15625 C 38.5 968.429688 40.636719 956.839844 40.636719 947.824219 C 40.636719 938.808594 19.25 923.355469 23.527344 916.917969 C 27.804688 910.476562 27.804688 891.160156 27.804688 884.722656 C 27.804688 878.28125 10.695312 869.269531 10.695312 861.542969 C 10.695312 853.816406 19.25 847.375 19.25 837.074219 C 19.25 826.769531 4.277344 816.46875 4.277344 810.027344 C 4.277344 803.589844 14.972656 794.574219 14.972656 785.5625 C 14.972656 776.546875 4.277344 768.820312 4.277344 761.09375 C 4.277344 753.367188 17.109375 745.640625 17.109375 737.914062 C 17.109375 730.183594 8.554688 725.035156 8.554688 717.308594 C 8.554688 709.582031 21.386719 703.140625 21.386719 692.839844 C 21.386719 682.535156 14.972656 679.960938 14.972656 669.660156 C 14.972656 659.355469 14.972656 624.585938 47.054688 557.621094 C 79.136719 490.652344 130.472656 435.277344 149.722656 414.671875 C 168.972656 394.066406 280.195312 318.085938 290.886719 302.632812 C 299.445312 290.269531 303.722656 240.820312 303.722656 217.640625 C 286.609375 216.351562 250.25 216.09375 250.25 209.914062 C 250.25 202.183594 293.027344 194.457031 297.304688 194.457031 C 300.726562 194.457031 300.15625 191.023438 299.445312 189.308594 C 294.308594 189.308594 284.472656 187.589844 280.195312 186.730469 L 280.195312 139.082031 C 280.195312 134.960938 274.488281 131.355469 271.636719 130.066406 C 269.5 100.449219 269.5 37.089844 286.609375 20.605469 Z M 286.609375 20.605469"
                fill="black"
              />
            </clipPath>
          </defs>
        </svg>
        {/* <svg width="0" height="0">
          <defs>
            <clipPath id="myClip">
              <path
                style={{ transform: `scale(${x}, ${y})` }}
                d="M66.9999 8C71.9999 0 96.9999 0 116.5 0C168 0 167 5.5 168.5 15.5C169.7 23.5 170 42.5 170 51H168.5V54.5V71.5C168.5 72 168 73 167 73C166.2 73 164 73.6667 163 74C167 77 175.5 79.1 175.5 81.5C175.5 83.9 167 83.5 163 84C163 95 164.1 114.6 164.5 117C165 120 182.5 136 188 145.5C206 173.5 212.5 185.5 219.5 206.5C226.5 227.5 231 255.5 231 259C231 262.5 229 264.5 229 269C229 273.5 232 276.5 232 279C232 281.5 230 284 230 287C230 290 233 293.5 233 296C233 298.5 230.5 300 230.5 304C230.5 308 232.5 309.5 232.5 314.5C232.5 319.5 229.5 320.5 229.5 324.5C229.5 328.5 231 328.5 231 333.5C231 338.5 226.5 344.5 226.5 346.5C226.5 348.5 228.5 353 228.5 356C228.5 359 224 367.5 224 370C224 372.5 226 379 225.5 381.5C225 384 221.5 392.5 221.5 395C221.5 397.5 224 405 224 407.5C224 410 220 415.5 220 422C220 428.5 222.5 430.5 222.5 433.5V451.5V606.5V662C228.5 686 230 702.5 231 714C232 725.5 233.5 754.5 233.5 767.5C233.5 780.5 225 798 220 805.5C215 813 202 817.5 194.5 817.5C188.5 817.5 178 814.167 173.5 812.5C167.1 813.3 151.5 811.833 144.5 811C138.5 816.5 129.5 819.5 127.5 819.5H111C101.4 819.5 93 814.5 90 812C87.5 813.5 69.5 812.5 64 812.5C58.5 812.5 51.5 815.5 47.5 816.5C43.5 817.5 29 818 21.9998 813C-5.50018 794.5 0.499823 746 1.49982 728.5C2.29982 714.5 8.16649 675.333 10.9998 657.5V540.5V433C11.9998 430.5 13.9998 423.5 13.9998 419C13.9998 414.5 9.99982 412 9.99982 406.5C9.99982 401 12.4998 399 12.4998 394.5C12.4998 390 6.99982 382 7.99982 379C8.99982 376 9.49982 371.5 9.49982 368C9.49982 364.5 4.49982 358.5 5.49982 356C6.49982 353.5 6.49982 346 6.49982 343.5C6.49982 341 2.49982 337.5 2.49982 334.5C2.49982 331.5 4.49982 329 4.49982 325C4.49982 321 0.999823 317 0.999823 314.5C0.999823 312 3.49982 308.5 3.49982 305C3.49982 301.5 0.999823 298.5 0.999823 295.5C0.999823 292.5 3.99982 289.5 3.99982 286.5C3.99982 283.5 1.99982 281.5 1.99982 278.5C1.99982 275.5 4.99982 273 4.99982 269C4.99982 265 3.49982 264 3.49982 260C3.49982 256 3.49982 242.5 10.9998 216.5C18.4998 190.5 30.4998 169 34.9998 161C39.4998 153 65.4998 123.5 67.9998 117.5C69.9998 112.7 71 93.5 71 84.5C67 84 58.4998 83.9 58.4998 81.5C58.4998 78.5 68.4998 75.5 69.4998 75.5C70.2998 75.5 70.1665 74.1667 69.9998 73.5C68.7998 73.5 66.4998 72.8333 65.4998 72.5V54C65.4998 52.4 64.1665 51 63.4999 50.5C62.9999 39 62.9999 14.4 66.9999 8Z"
                fill="black"
              />
            </clipPath>
          </defs>
        </svg> */}
      </div>
    )
  }
}

export default BottleWithDroplets
